export default "__VITE_ASSET__CWw5SBQc__"